module.exports = __webpack_public_path__ + "static/media/7Rectangle.28bbae0a.png";